import { createRoute, useParams } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { CourseLearnView } from "@/features/courses/components/player/course-learn-view";

function LearnCoursePage() {
  const params = useParams({ from: "/u/$u/learn/$courseId" });
  return <CourseLearnView courseId={params().courseId} />;
}

export const learnCourseRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/learn/$courseId",
  component: LearnCoursePage,
});
